@if (isCollapsed) {
<div class="container" (click)="toggleCollapsed()">
  <div class="row h-4rem align-items-center">
    <div class="col-3 d-flex justify-content-start align-items-center" role="button" (click)="toggleCollapsed()"> 
      <i class="pi pi-arrow-down" style="font-size: 1rem; color: #719eb6"></i>
      <button
        type="button"
        class="btn btn-primary position-relative program-name" style="margin-left: .75rem;"
      >
        {{ reminder?.Name }}
      </button>
    </div>
    @if (!!reminder?.DateDeleted) {
      <div class="col-1 d-flex justify-content-end align-items-center">
        <p-tag id="deleted-tag" severity="danger" value="Deleted" />
      </div>
      }
  </div>
</div>
} @else {
<div class="container">
  <div class="row h-4rem align-items-center">
    <div class="col-4 d-flex justify-content-start align-items-center" role="button" (click)="toggleCollapsed()"> 
      <i class="pi pi-arrow-up" style="font-size: 1rem; color: #719eb6"></i>
      <button
        type="button"
        class="btn btn-primary position-relative program-name" style="margin-left: .75rem;"
      >
        {{ reminder?.Name }}
      </button>
    </div>
    @if (!!reminder?.DateDeleted) {
      <div class="col-1 d-flex justify-content-end align-items-center">
        <p-tag id="deleted-tag" severity="danger" value="Deleted" />
      </div>
      }
    <div [ngClass]="{'col-8': !reminder?.DateDeleted, 'col-7': !!reminder?.DateDeleted }">
      <div class="side-menu-buttons-horizontal">
        <button (click)="editReminder()" class="side-menu-button2">
          Edit Reminder
        </button>
        @if (!reminder?.DateDeleted) {
          <button (click)="deleteReminder()" class="switch-mode-button">
            Delete Reminder
          </button>
        }
        @else{
          <button
            (click)="restoreReminder()"
            class="side-menu-button2"
            [style.opacity]="'1'"
          >
            Restore Reminder
          </button>
        }
      </div>
    </div>
  </div>

  <div class="row">
    <p-table [value]="[reminder]" [tableStyle]="{ 'min-width': '40rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th style="text-align: center;">Name</th>
          <th style="text-align: center; width: 35rem;">Message</th>
          <th style="text-align: center">Type</th>
          <th style="text-align: center">Days</th>
          <th style="text-align: center">Time</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-target>
        <tr>
          <td style="text-align: center">
            {{ reminder?.Name }}
          </td>
          <td style="text-align: start; width: 35rem;">
            {{ reminder?.Message }}
          </td>
          <td style="text-align: center">
            {{ reminder?.Type }}
          </td>
          <td style="text-align: center">
            {{ getDays(reminder?.Days) }}
          </td>
          <td style="text-align: center">
            {{ getTime(reminder?.Time) }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">No reminders found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
}
